// src/api/serverApiConfig.ts
import axios from 'axios';
 
// Get the SERVER_BASE_URL from the environment
const operationServiceApiInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_SERVICE_SERVER_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});
operationServiceApiInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default operationServiceApiInstance;